/**
 * The cookie remembering which sport is being worked on.
 *
 * Deliberately its own module with no `"use client"`: a constant exported from
 * a client component reaches a server component as a client *reference*, not
 * the string, so `cookies().get(...)` silently looked for a cookie named
 * "[object Object]" and always came back empty.
 */
export const SPORT_COOKIE = "omnium.sport";

/** How long a remembered sport survives, in seconds (a year). */
export const SPORT_COOKIE_MAX_AGE = 31_536_000;

/**
 * The remembered sport, read from the browser's cookies.
 *
 * The Next version read this on the server and handed it to the layout. There
 * is no server now, so the layout reads it here — and it has to read it
 * somewhere, because the sidebar only keeps its sport in component state. Any
 * full page load of a route that is not sport-scoped (a fixture, the scoring
 * console) starts that state empty, and the sidebar then writes the empty value
 * back over the cookie, losing the sport for good.
 */
export function readRememberedSport(): string | null {
  if (typeof document === "undefined") return null;
  const prefix = `${SPORT_COOKIE}=`;
  const hit = document.cookie.split("; ").find((c) => c.startsWith(prefix));
  if (!hit) return null;
  try {
    return decodeURIComponent(hit.slice(prefix.length)) || null;
  } catch {
    // A cookie somebody hand-edited is not worth throwing over.
    return null;
  }
}
